/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "返回",
      "<h3 class=”header-3”>無障礙功能狀態</h3> <p>根據歐洲無障礙法案規定，設計電子商務服務（包括辨識及支付方式）時，無障礙功能服務應明顯、易讀、好操作、效能佳。此外，我們致力根據 <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">W3C 的「無障礙網頁設計規範 2.1 AA 級」</a>，設計我們的網站及行動應用程式。為了達成目標，我們已：</p> <ul> <li>與無障礙功能顧問公司合作，例如 Level Access，了解如何提升服務的無障礙效能。</li> <li>根據全球無障礙功能標準，評估使用者的數位體驗。</li> <li>汲取無障礙功能專家的建議，並聽取身心障礙者及其他需求的意見，調整我們的設計。</li> </ul>",
      "<h3 class=”header-3”>意見回饋與聯絡方式</h3> <p>我們盡力確保所有使用者都能使用，但仍可能有一些限制。歡迎提供意見，協助我們改進，如果你遇到阻礙或需要其他形式的資訊，請來信至 accessibility@bumble.com 告知我們需要哪些協助。</p>",
      "<h3 class=”header-3”>持續改良</h3> <p>我們的無障礙作業持續推動，致力達成以下目標：</p> <ul> <li>監控和審查所有數位平台的無障礙功能。</li> <li>修復已知問題，並透過無障礙設計防止問題。</li> <li>擴大內部訓練並提高意識，加強推動無障礙設計效能。</li> </ul>",
      "<h3 class=”header-3”>最後更新日期：2025 年 11 月</h3>",
      "<h3 class=”header-3”>採取的措施</h3> <p>為提升服務的無障礙功能，我們所做的努力如下：</p> <ul> <li>與 Level Access 合作執行完整的無障礙評估及指引。</li> <li>內建無障礙工具至平台，包含輔助技術、替代鍵盤、語音功能、無觸控導覽。</li> <li>執行身心障礙使用者測試，根據實際意見回饋改良功能。</li> <li>整合無障礙設計，執行產品開發生命週期及品質管控程序。</li> <li>在組織內推行無障礙功能計畫。</li> <li> 導入 <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">輔助功能客戶體驗平台</a>。這個平台免費開放給較難打字、做手勢、移動滑鼠或閱讀的使用者，內建的工具包括替代的滑鼠及鍵盤、語音辨識、語音啟用、免持或免觸控導航等。</li> </ul>",
      "<h3 class=”header-3”>我們的政策</h3> <p>在 Bumble，公平是我們的核心價值觀。對我們來說，這不僅僅是一個流行語，我們正致力於讓 Bumble 的體驗變得無障礙、公正且平等。</p> <p>本無障礙聲明旨在告知會員關於我們服務的無障礙程度，包括與相關法律及技術標準的一致性。本聲明適用於受《歐洲無障礙法案》規範的服務元素，特別是我們的電子商務服務，這些服務允許會員升級至一系列進階的付費 Bumble 功能，並可透過 Bumble 應用程式存取。</p>",
      "《歐洲無障礙法案》(EAA) 無障礙聲明",
      "在 App Store 下載",
      "在 Google  Play 下載",
      "圖文",
      "簡報 {{number}}",
      "下一張簡報",
      "上一張簡報",
      "簡報",
      "簡報 {{number}}，共 {{total}} 頁",
      "不可販售或分享我的個人資料",
      "不許售賣或分享我的個人信息",
      "在 Bumble上送出 Compliments，表達你喜歡他們，並在配對之前吸引他們的注意力。現在就試試看",
      "Compliments | 如何傳送 Compliments | Bumble",
      "個人化頁面每天更新，與你最合拍的人就在眼前。",
      "探索 | 尋找合拍對象 | Bumble",
      "以自己的步調約會，並且使用隱身模式保有Bumble個人資料的控制權。瞭解如何在Bumble上使用隱身模式，請參閱我們的指南。",
      "隱身模式 | 隱藏個人資料 | Bumble",
      "難得在 Bumble 實體活動相遇，不妨在應用程式延續話題，讓好感持續升溫。",
      "立即配對 | 在應用程式延續話題 | Bumble",
      "需要一點休息或是為自己的時間嗎？了解如何使用 Bumble 的瞌睡模式暫停你的 Bumble 帳戶，按照自己的步伐約會。",
      "瞌睡模式 | 暫停帳戶 | Bumble",
      "在Bumble上看到一位真的很喜歡的人嗎？使用超級滑動表達你的誠意。在他們的個人資料上點選星號開始，或在此處查看更多詳細資訊",
      "Bumble 超級滑動 | 什麼是超級滑動？ | Bumble",
      "旅行以工作或遊戲為目的？Bumble 的旅行模式可幫助你在新地方建立有趣的新連結，並在旅途中約會。現在就在此處探索旅行模式。",
      "Bumble 的旅行模式 | 在任何地方約會 | Bumble",
      "想知道你在訊息中感受到的連結是否意味著現實中的化學反應？現在在 Bumble 上進行視訊聊天或語音通話，看看是否真的有感覺",
      "視訊聊天 | 撥打電話 | Bumble",
      "Bumble Date",
      "我們的應用程式",
      "關於",
      "工作機會",
      "聯絡我們",
      "投資者",
      "商店",
      "公司",
      "下載應用程式",
      "Bumble 的無障礙政策",
      "指導原則",
      "管理 Cookie",
      "現代奴役法案",
      "資料收集聲明",
      "隱私權政策",
      "條款與細則",
      "法務",
      "華盛頓州消費者健康資料隱私權政策",
      "掃瞄 QR 碼，即可下載 Bumble 應用程式",
      "登入",
      "在此終止合約",
      "立即下載",
      "掃瞄 QR 碼，即可開始使用。",
      "尋找下一位約會對象",
      "下載應用程式",
      "Bumble 首頁",
      "選擇選單",
      "打開選單",
      "即將登場：Bumble 愛情故事",
      "選擇你的語言",
      "選擇語言",
      "腳註",
      "Bumble的無障礙功能",
      "Apple 和 Apple 標誌是 Apple Inc. 的商標",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "工作機會",
      "活動",
      "Google Play是 Google LLC 的商標。",
      "指導原則",
      "投資家",
      "管理 Cookie",
      "管理 Cookie",
      "現代奴役法案聲明",
      "資料收集聲明",
      "隱私權政策",
      "不同季節的約會指南",
      "條款",
      "應用",
      "Washington Consumer Health Data Privacy Policy",
      "關於",
      "大使",
      "結交新朋友，尋找自己的社群",
      "拓展專業網絡，令事業更進一步",
      "認真戀愛、隨意約會或其他關係",
      "The Buzz",
      "瞭解更多",
      "使用旅行模式全球行動",
      "約會",
      "活動",
      "功能",
      "Compliments™",
      "送出 Compliments 讓自己脫穎而出。",
      "探索",
      "個人化頁面每天更新，與你最合拍的人就在眼前。",
      "隱身模式",
      "使用隱身模式隱藏檔案，不讓同事、親友或前任看見你。",
      "立即配對",
      "在 Bumble 實體活動聊不久？應用程式裡繼續聊！",
      "瞌睡模式",
      "透過瞌睡模式先暫停一下，準備好約會時再回歸。",
      "超級滑動",
      "對方檔案看起來還不錯？透過超級滑動讓對方知道。",
      "旅行模式",
      "透過旅行模式在全球配對。",
      "視訊聊天",
      "通過視訊和語音通話，嘗試判斷是否準備好面對面見面。",
      "下載 Bumble 應用程式",
      "BFF",
      "安全",
      "故事",
      "支援",
      "商店",
      "主要",
      "向對方送出讚美，讓自己脫穎而出。",
      "讚美",
      "功能經過精心設計，旨在創造一個真實、互相尊重和有意義的空間，讓會員互相連結。",
      "隱藏個人檔案，不讓老闆、親戚或前任看見你。",
      "隱身模式",
      "利用「瞌睡模式」暫停交友。",
      "瞌睡模式",
      "看到喜歡的人嗎？讓對方知道你的心意。",
      "超級滑動",
      "探索 Date",
      "出國除了買免稅小吃，還可隨時隨地與人配對。",
      "旅行模式",
      "無需出門，也有如真人見面。",
      "視訊通話",
      "從瀏覽器直接享受 Bumble 體驗。",
      "應用程式網頁版",
      "我們的領袖致力將 Bumble 的價值觀，帶進各個社群。",
      "社群領袖",
      "功能經過精心設計，旨在協助你找到適合你的人，交流共同興趣。",
      "籌備群組聚會，或探索附近的地區活動。",
      "聚起來",
      "探索 BFF",
      "助你尋找愛情和友誼的各種指引和靈感。",
      "與你分享各種建議和故事，助你建立理想友誼。",
      "友誼中心",
      "從東京到多倫多，在 Bumble 上成功尋愛的故事遍佈全球。",
      "愛情故事",
      "無論何時、何地、與誰約會，都要計劃完美約會。",
      "不同季節的約會指南",
      "探索故事",
      "直接前往主內容",
      "Bumble 標誌",
      "關閉導覽選單",
      "打開導覽選單",
      "Bumble 創辦人兼 CEO Whitney Wolfe Herd 的人像照",
      "Whitney Wolfe Herd 創立 Bumble 只有一個目標，就是建立一個最可靠的空間，讓會員尋找愛情。這是一個由女性主動出擊的空間，交流以尊重為本。{{__EOL__}}{{__EOL__}}作為 CEO，她仍然抱持同一個信念引領大家：在網上尋找愛情，本應是有意識、安全和真實的。Bumble 不只著重於約會，還帶著關懷、意志和熱心，協助會員尋找他們看重的東西。因此，我們利用科技和 AI 讓人與人之間有更深層次的交流，而不是取代人際關係。我們現在運用一切所學，包括各種優點、瑕疵和真誠，務求讓整個社群繼續舒服自在地使用 Bumble。",
      "Whitney Wolfe Herd",
      "一對微笑著的伴侶在汽車後座牽著手靠近彼此，準備接吻，車外有綠色植物。",
      "我們相信，各種形式的愛，就是幸福健康生活的基礎。",
      "你好，我們是一間以愛為本的公司。",
      "Bumble 配對畫面，展示兩個個人檔案和展開對話的提示。",
      "結果？一個以會員為中心的平台成立，致力促進善良、健康的連結。",
      "{{date}} 年，我們重新定義約會規則。",
      "我們的任務，就是讓大家靠近愛多一點。",
      "我們的使命",
      "我們翻轉了約會常規，交由女性主動出擊。",
      "Bumble 誕生",
      "{{bff}} 登場，幫助會員尋找同道中人，因為純友誼也是愛的一種。",
      "超越約會",
      "Serena Williams 幫我們將由女性主動出擊的概念，帶到超級盃場上。",
      "初登超級盃",
      "在新冠疫情期間，我們推出新功能應付當時的約會需求。",
      "約會轉移到虛擬世界",
      "本公司上市，創造最年輕女性帶領公司上市的記錄。",
      "創造歷史",
      "除了研發反網絡暴露技術外，我們也擴充了保護婦女的政策。",
      "提升安全保障",
      "我們讓女性運動成為眾人焦點，發出應有的光芒。",
      "WNBA x Bumble",
      "現在，我們致力建構一個未來，讓每一個人都感覺到愛是觸手可及的。",
      "以愛引領前行",
      "最初，我們踏出大膽一步。今天，我們努力建構一個最可靠和有效的地方，讓會員尋找愛情。",
      "捲動即可探索",
      "向左捲動",
      "向右捲動",
      "我們的故事",
      "查看職位空缺",
      "協助我們建立尋找愛情最可靠的地方。",
      "與我們一起工作",
      "BFF 應用程式畫面，突顯使用者個人檔案檢視模式和興趣徽章，方便與朋友連結",
      "無論你是剛剛搬到一個新城市，還是想擴闊社交圈子，{{bff}} 都能讓你輕鬆地認識與你志趣相投而且同頻的人。",
      "尋找適合你的人",
      "多個 Bumble 個人檔案的拼貼圖，展示不同會員擁有已通過證件驗證徽章，置中的個人檔案展示一名女士對鏡自拍。",
      "無論你是約會新手還是準備捲土重來，Bumble Date 都能以安全的方式讓你靠近愛多一點，建立有意義的關係。",
      "尋找你的那一位",
      "一名女士在公園裡拿著滑板微笑著",
      "戶外活動",
      "一名男士在城市公園中微笑著跑步",
      "跑步",
      "一名女士在戶外抱著一隻毛茸茸的小狗",
      "狗主",
      "下載 Bumble",
      "我們希望會員能夠找到有意義和真實的關係，點燃內心的自信和快樂。",
      "我們的存在，就是讓大家靠近愛多一點。",
      "一名深色頭髮的女士束著長馬尾，穿著黑色上衣，太陽眼鏡架在頭上，她背著大海微笑著。",
      "一名身穿圖案襯衫的山羊鬍男士拿著相機站在戶外，背景有樹木和建築物。",
      "一名女士穿著紅色彩虹條紋外套，戴著銀色耳機和綠色星星項鍊，看著鏡頭。",
      "一對伴侶微笑著擁抱的黑白人像照",
      "{{name1}} 和 {{name2}}，{{num}} 年結婚",
      "瞭解更多",
      "閱讀更多故事",
      "「{{__EOL__}}我倆都是天生正能量滿滿的樂天派實幹型。當你們把我們拉在一起之後，世界上好像沒有我們做不到的事了。",
      "兩個人在網球場上大笑，其中一人拿著網球遮蓋自己雙眼",
      "真人見面",
      "Bumble 實體活動讓你可以停止打字，開始交談。單獨來還是帶朋友來也沒關係，最重要是離開時多了一個新對象。",
      "面對面展開對話",
      "會員享受在 Bumble 上透過照片、視訊對話和專家建議建立連結。",
      "登記",
      "加入「會員圈」，攜手塑造 Bumble 的未來。這個由會員組成的特定社群能通過對話、討論和產品測試，直接與我們的團隊分享想法。{{__EOL__}}{{__EOL__}}參與者可搶先使用新功能、提前收到新活動消息，而且有機會協助 Bumble 為所有人做得更好。",
      "分享你的想法",
      "想認識對方嗎？在 Bumble 使用視訊聊天。",
      "簡單地點選您的聊天中的視訊圖示以開始視訊通話，無需分享任何個人聯絡資料。",
      "如何在 Bumble 上進行視訊聊天？",
      "不。所有在平台上的通話和聊天， Bumble 都會保護你的個人資料安全。在你決定跟對方分享前，沒有人可以獲得你的號碼或任何其他聯絡資料。",
      "我的配對會看到我的電話號碼嗎？",
      "嗯，如果你還沒準備好面對面，語音通話可以讓你透過聲音進行連接。只需選擇通話圖示即可。",
      "我可以嘗試一下語音通話嗎？",
      "我們喜歡收到好消息通知。但我們知道討論是否會像面對面一樣好很難判斷。這就是視訊和音訊通話的用途。",
      "在 Bumble 上進行視訊聊天",
      "<a href={{video_chat_url}}>視訊聊天和語音通話</a>可以幫助你了解對方，並決定是否要見面。最好的部分？當你透過 Bumble 進行通話時，你不必交換電話號碼，因此你的個人資訊在你準備分享之前都很安全。",
      "用視訊聊天來測試你們的化學反應",
      "闖關於線上和線下約會之間的隙縫，並決定是否時候展開相遇。",
      "了解他們更好（及更快）。面對面的對話或電話對話可以揭示很多關於某人的資訊。",
      "完全由你掌控。我們不會分享你的聯絡資料，你可以自己選擇何時分享。",
      "看看你是否準備好面對面見面",
      "嘗試快速氛圍檢查",
      "無需提供個人資訊即可連接",
      "為什麼你應該使用視訊聊天和通話",
      "準備好開始對話了嗎？您可以從 Bumble 應用程式的聊天中選擇開始語音通話或視訊通話。要開始視訊通話，請點選右上角的灰色視訊相機圖示。您還會看到圖示旁邊的三個點，點選此處，您將看到音訊通話的選項。",
      "如何視訊聊天",
      "準備好體驗 Compliments™",
      "當你傳送 Compliment 時，收到的人會在你在他們的「推薦給你」分頁看到。",
      "當你在 Bumble上 讚美某人時會發生什麼事？",
      "如果他們的讚美引起了你的注意，就隨意與他們配對。你會在你的聊天中看到讚美，並且「<a href={{make_the_first_move_url}}>主動出擊</a>」的規則適用。",
      "如何回應讚美？",
      "你可以免費傳送 {{num}} 個[[Compliments:num]]。用完時，可以在 Bumble 應用程式中購買更多 (最多 30 個）。你可以盡情使用讚美。請放心，讚美不會過期！",
      "我可以發送多少個 Compliments？",
      "好話帶來的好處多多。如果你想表達讚美，但是不知道要說什麼，請嘗試以下這些靈感：",
      "查看更多例子",
      "「喜歡 [藝人名稱] 的人都有好品味。」",
      "「微笑傳染性很強！」",
      "「你的自我介紹好好笑。 寫得不錯！」",
      "Bumble 如何傳送更好的讚美",
      "想要讓對方擁有美好一天嗎？似乎你已準備好要使用 Compliments™ 了！",
      "Bumble Compliments",
      "使用對 Bumble 的 Compliments 功能，讓潛在的對象知道你喜歡他們 (甚至可能讓他們臉紅)。 {{service_level_lexeme_name}} 會員會獲得讚美額度，讓你在還沒有配對成功前就可以發送訊息給對方 (或收到對方訊息)。",
      "Compliments 功能的運作方式",
      "當你收到讚美時，讚美人的資料會出現在你的「推薦給你」分頁中。你還會收到通知，告訴你有人喜歡你。",
      "查看你收到的 Compliments",
      "你可以透過點選某人個人資料底部的黃色心形圖示來發送讚美。點選的位置很重要，因為你將讚美該特定照片或個人資料的部分！你點選時會開啟一個對話框，供你寫下訊息（請確保為150 個字元！）。",
      "送出讚美",
      "馬上下載 Bumble\n體驗「探索」功能",
      "每天早上 9 點起，你就可在「探索」頁面看到新的推薦對象。看看與對方有什麼共通點，盡情交流。",
      "「探索」頁面在什麼時候更新？",
      "你的「探索」頁面將潛在配對分為 3 個主要類別：相似興趣、相同約會目標和共同社群，還會根據你先前的配對推薦個人檔案。",
      "「探索」頁面的內容是如何挑選的？",
      "個人化頁面每天更新，與你最合拍的人就在眼前",
      "尋找與你同頻的人\n馬上開始 {{qr_code}} 探索",
      "「探索」頁面根據你的共同興趣、約會目標和社群，向你推薦各種我們認為你會喜歡的人。",
      "體驗「探索」",
      "想用不一樣的方式\n找到和你有共鳴的人？",
      "「探索」頁面每天更新，向你推薦更多與你合拍的人，好讓你省下尋覓配對的時間，專注與來電的對象深入交流。",
      "推薦對象\n每日更新",
      "「探索」頁面根據你的個人檔案和你之前的配對對象推薦對象，無論你愛吃素龍蝦包，還是追求長遠關係，都能遇見與你臭味相投、志同道合的人。",
      "個人化體驗{{__EOL__}}以你為先",
      "下載 Bumble",
      "常見問題與解答",
      "準備好私密地逛逛 Bumble 嗎？",
      "啟用隱身模式後，你將不會出現在其他 Bumble 成員中，除非你喜歡他們的個人資料。",
      "隱身模式如何運作？",
      "如果沒有隱身模式，你的個人資料會在 Bumble 顯示給其他會員 (當你符合他們的喜好，例如年齡和位置)。當你啟用隱身模式時，僅會在你喜歡他們後，你的檔案才會顯示給對方看。",
      "誰可以在 Bumble 的「隱身模式」中看到我？",
      "使用隱身模式並不等於在 Bumble 上<a href={{blocking_on_bumble_url}}>封鎖</a>某人。使用此功能時，如果你喜歡某人 (或是在過去與他們對話)，他們將能夠看到你的個人資料。",
      "隱身模式就像封鎖某人嗎？",
      "使用 Bumble 的隱身模式控制誰可以查看個人資料",
      "Bumble 的隱身模式",
      "如果你想要退一步，或在 Bumble 上看看其他交友者的個人資料而不被他人看到你的個人資料，則可以啟用隱身模式。啟用此功能後，我們將隱藏你的個人資料，除非你先喜歡他們。這允許你控制你要分享的內容，以及誰可以看到你的檔案。",
      "切換到隱身模式隱藏檔案",
      "你決定誰可以看到你的相片和個人資訊。",
      "想在個人資料上加入一些個人化內容嗎？你可以私密地與當前配對分享內容。",
      "隨意逛逛，不必擔心會遇到前任、同事或是不在你愛情雷達上的人。",
      "完全掌握",
      "選擇想分享的內容",
      "避免尷尬",
      "為什麼你會愛上隱身模式",
      "隱身模式適用於 {{service_level_lexeme_name}} 和 {{service_level_lexeme_name_two}} 會員。註冊後，可以前往你的個人資料分頁，點選右上角的「設定」，然後切換到隱身模式。",
      "升級到 {{service_level_lexeme_name}}",
      "如何在 Bumble 上使用隱身模式",
      "馬上下載 Bumble\n體驗「立即配對」",
      "在 Bumble 應用程式中，按一下螢幕底部的個人檔案圖示，QR 碼圖示就在螢幕的右上角，按一下即可使用。",
      "我可以在哪裡找到我的個人 QR 碼？",
      "必須透過網路或Wi-Fi，連接到互聯網，並使用即時QR碼，才能開始「快速配對」",
      "我可以將 QR 碼截圖分享嗎？",
      "不用。只要其中一人掃瞄 QR 碼，你們便會自動配對。",
      "兩個人都需要掃瞄 QR 碼嗎？",
      "立即配對，秒看你與新配對的共通點，合拍指數瞬間揭曉。",
      "更快找出\n你們的共通點",
      "在 Bumble 實體活動聊不夠？應用程式裡繼續聊！",
      "遠遠超於一次相遇\n{{qr_code}} 立即配對",
      "「立即配對」幫你將初次相遇提升到每天聊聊的層次，而且不用交換號碼或社交帳號。請對方掃瞄你的 QR 碼，即可在 Bumble 上配對。",
      "體驗「立即配對」",
      "在 Bumble 實體活動遇見心儀對象？",
      "「立即配對」讓你可先在應用程式瞭解對方的個性，而無需交換社交帳號或電話號碼。全靠 Bumble 的一系列安全功能，你們可以放心用自己的方式互相認識。",
      "安全保障升級\n讓你放心交友",
      "難得在 Bumble 實體活動遇上醉心泡出完美手沖咖啡的同道中人，或者細心照料罕有多肉植物的知音？不妨在應用程式延續話題，交流共同興趣，讓美好延續。",
      "讓對話\n延續下去",
      "想要休息一下嗎？嘗試使用瞌睡模式",
      "是的，你可以隨時前往你的設定或佇列，關閉暫停模式。",
      "可以提前關閉瞌睡模式嗎？",
      "前往設定，點選暫停，然後選擇你想要遠離的時間。當你準備好時，隨時回來。",
      "如何在個人資料中使用瞌睡模式？",
      "不，在瞌睡模式下, 所有滑動和聊天活動都會暫停。 如果你去看你的佇列, 你會看到一個告訴你瞌睡模式將會持續多久的訊息, 並且有選項可以停用它。",
      "開啟「瞌睡模式」後，我還能繼續探索個人檔案和與人對話嗎？",
      "已經與你開始對話的人將會看到你的「離開」狀態 (如果您選擇設定)。否則，他們將會在收件匣中以正常方式看到你先前的訊息。",
      "當我啟用瞌睡模式時，目前的配對將會看到什麼？",
      "你對你的 Bumble 活動有完全的控制權，並且可以隨時離開平台。",
      "你可以使用狀態更新與現有配對保持聯絡，以避免他們以為你<a href={{ghosted_article_url}}>消失</a>了。此外，這全部都是自動化的，因此你不需要發送任何消息。",
      "你可以隨時選擇停止積極約會，但不會失去現有的配對或聊天記錄",
      "依自己的規則約會或離開",
      "保留你的配對",
      "暫停活動，而非連結",
      "為什麼我們喜愛瞌睡模式",
      "開啟 Bumble 應用程式，造訪你的個人檔案分頁，並點選右上角的設定齒輪。在設定中，點選暫停並選擇你要離開的時間。你可以隱藏個人檔案 24 小時、72 小時、一週或無限期。{{__EOL__}}{{__EOL__}}請記住，在瞌睡模式下，沒有聊天的配對將過期。如果你決定設定狀態，你正在聊天的人將能夠看到你離開了。",
      "Bumble 的瞌睡模式如何運作",
      "當生活忙碌時，瞌睡模式將能幫助你暫停你的 Bumble 帳戶，讓你按照自己的步伐約會。",
      "Bumble 瞌睡模式",
      "「瞌睡模式」讓你在想暫停交友時，可以輕鬆暫停帳戶。你仍然可以與現有連結對話，系統只會對其他會員隱藏你的個人檔案，直到你準備好重新開始為止。啟用「瞌睡模式」並不會失去個人資料或刪除現有連結。",
      "暫停你的 Bumble 個人檔案",
      "當你在「瞌睡模式」時，你可以選擇透過更新狀態，讓現有連結知道你正在休息。你可以選擇「旅行中」、「埋首工作中」、「數碼排毒中」或「我要先處理自己的事情」。無論你的狀態如何，我們都會支持你。",
      "新增「外出」狀態",
      "啟用瞌睡模式暫停你的 Bumble (或{{page_partner_name_bff}}) 帳戶。你的配對將不會知道你正處於瞌睡模式，除非你告訴他們。如果你決定提前從瞌睡模式中醒來，只需返回設定並點選「停用瞌睡模式」即可。",
      "暫停聊天",
      "在 Bumble 上嘗試超級滑動",
      "{{service_level_lexeme_name}} 使用者每週可以取得 {{num}} \n 個「[[superswipe:num]] 」，但是你可以隨時增加額度。免費會員可以購買「超級滑動」的套裝方案。",
      "在 Bumble上，我可以發送多少個超級滑動？",
      "如果有人對你使用超級滑動，你會立即收到通知。你還會在對方的個人資料上看到一個標籤，你就能知道對方很喜歡你。",
      "如何知道有人對我使用了超級滑動？",
      "對某人一見鍾情嗎？有一個很好玩的方式可以打破沈默，就是使用「超級滑動」讓對方知道你對他們有興趣，讓你們更快進入聊天。",
      "Bumble 超級滑動",
      "從人群中脫穎而出不容易，但超級滑動可以幫你留下良好的第一印象。{{__EOL__}}{{__EOL__}}使用超級滑動時，系統會向你喜歡的人發送通知。你的個人資料會跳到他們的隊伍頂端，並標上標籤。如果他們也喜歡你，就可以開始聊天了。",
      "什麼是超級滑動？",
      "勇敢行動並脫穎而出",
      "開啟更多聊天",
      "認識更多朋友",
      "超級滑動可以幫助你...",
      "如果你有 <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> 或 Bumble {{service_level_lexeme_name_one}}，每週可獲得 {{num}} 個免費的[[superswipe:num]]。此外，所有成員都可以從個人資料分頁購買最多 {{num_two}} 個[[superswipe:num_two]]。如果你擁有{{service_level_lexeme_name_three}}，每週將獲得 {{num_three}} 個免費的[[superswipe:num_three]]。{{__EOL__}}{{__EOL__}}使用超級滑動非常簡單。當你看到喜歡的人時，只需點選底部左角。",
      "如何使用超級滑動",
      "使用 Bumble 的旅行模式在旅途中約會",
      "<a href={{bumble_premium_url}}>{{service_level_lexeme_name}} 會員</a>可以使用旅行模式。開啟之後，你的佇列將顯示所選城市的新人。",
      "如何使用旅行模式？",
      "基本上，我們有一些安全限制可能會隨時間改變，但旅行模式適用於大多數目的地。",
      "我可以在任何地方使用旅行模式嗎？",
      "旅行模式會將你的位置顯示為所選城市，因此當地的新連接可以找到你，對方將在你的個人資料上看到註記，知道你正在旅行中或計劃旅行。",
      "準備出發度假或前往新城市工作？開啟 Bumble 的旅行模式，隨時隨地約會。",
      "Bumble 旅行模式",
      "旅行模式是你在外旅行時建立連結的最佳工具。將你的位置設定為世界上任何地方，你的個人資料將顯示在選擇的城市中。這表示你可以在旅途中所在的城市進行配對。",
      "旅行模式是什麼？",
      "沒有人比當地人更瞭解當地。旅行模式可以幫助你與特別的人建立連結，使旅程更加精彩。",
      "至少在七天之前設定你的旅行城市，以便預先計劃日期並與潛在配對建立連結。",
      "不僅是海灘旅程，也可能是在假期回家一趟、出差或探索新城市。在任何地點都能尋找浪漫。",
      "尋找最適合的當地約會地點",
      "去探險",
      "結交有意義的連結",
      "熱愛旅行模式的原因",
      "旅行模式適用於 <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} 和 {{service_level_lexeme_name_two}}</a>會員在 Bumble。點選右上角你的個人資料中的設定齒輪，滾動直到看到旅行模式。選擇你的新位置以開始看到該區域的人。你的個人資料會通知潛在的約會對象你正在旅行模式中。",
      "旅行模式如何使用？",
      "試看看",
      "在這裡，友善最性感，做自己最完美，且由女性採取主動！",
      "Make The First Move™ 的堡壘",
      "美好的生活離不開健康的人際關係。無論是約會、交友、拓展人際網，Bumble 都是最有力的建立人際關係的社交工具。",
      "Bumble 的重要性",
      "我們鼓勵正直、友善、平等、自信，並尊重所有階段的關係。我們更是歡迎所有性向的人，不論是要找另一半，還是單純交友。",
      "Bumble 的價值",
      "在 Bumble，女性需要邁出第一步，或是設定 Opening Move 讓所有新配對都可以回覆。我們顛覆傳統約會方式，鼓勵兩性平權。",
      "Bumble 運作方式",
      "關於我們",
      "馬上下載",
      "App 的體驗更好",
      "使約會變得更加有意思的新功能",
      "2024 年 2 月 12 日",
      "如何增加感情的情感親密度",
      "2024 年 1 月 25 日",
      "沒有使用過約會應用程式的人該如何使用 Bumble",
      "2024 年 2 月 5 日",
      "Deception Detector™",
      "約會最新消息",
      "透過<b>瞌睡模式</b>先暫停一下，準備好約會時再回歸。",
      "休息一下",
      "使用<b>視訊</b>和<b>語音通話</b>功能，在出門見面之前先認識對方。",
      "來電了",
      "查看更多",
      "使用 <b>Opening Moves</b> 讓對方開啟對話，你也不用想破腦袋。",
      "輕鬆約會",
      "透過<b>旅行模式</b>在全球配對。",
      "帶我一起飛",
      "對方檔案看起來還不錯？透過<b>超級滑動</b>讓對方知道。",
      "吸引對方注意",
      "送出 <b>Compliments</b> 讓自己脫穎而出。",
      "讓對方臉紅心跳",
      "使用<b>隱身模式</b>隱藏檔案，不讓同事、親友或前任看見你。",
      "臥底行動",
      "照自己的方式約會",
      "幾個月後，她也在那遇見她的伴娘",
      "Hannah 在 Bumble 上遇見她的老公。",
      "在一起建立小窩之前，Carène 和 You-Liang 在 Bumble 上相遇，當時 You-Liang 受到 Carène 的旅遊照片吸引。",
      "Carène 和 You-Liang",
      "Brian 和 Kaci 都派駐在海外，但他們是在 Bumble 上相遇的",
      "Brian 和 Kaci",
      "如果他們可以，你也可以",
      "邁出下一步",
      "更新內容",
      "你值得更好的體驗，我們設計的全新方式讓你無壓交友。",
      "不需要降低標準",
      "關於 Bumble",
      "我們是唯一優先考量女性約會體驗的交友應用程式，因為女性快樂的世界，是更好的世界。",
      "Make the first move™",
      "尋找想約會的對象，並勇敢邁出第一步。建立真誠的連結、透過共同興趣認識對方，並享受快樂時光。",
      "透過 Bumble Date 尋找特別的那個人",
      "尋找職涯路上的好友，與其他同業結交，尋找新工作，創造事業。",
      "透過 Bumble Bizz 拓展人脈",
      "遇見同道中人，或是不同世界的人！不論是在家中或在旅途中，交新朋友，一起展開新冒險！",
      "在 Bumble For Friends 上交新朋友",
      "這個平台已不再限於約會",
      "Bumble 這個約會應用程式，由女性邁出第一步，建立有意義的關係跟社群。立即下載。",
      "Bumble 的 {{social_network}}",
      "瞭解更多",
      "為了提供最佳體驗及安全功能，Bumble 現在只能在應用程式上使用。{{__EOL__}}{{__EOL__}}如想要體驗不中斷，請從 App Store 或 Google Play 下載 Bumble 應用程式至手機或平板電腦，並使用你在網頁版 Bumble 的同一個帳戶登入。{{__EOL__}}{{__EOL__}}請使用你的手機或平板電腦掃描下方的 QR 碼開始使用。{{__EOL__}}{{__EOL__}}你的配對對象及對話正在應用程式上等著你。💛",
      "下載應用程式",
      "因此，為了繼續為你帶來最佳體驗和安全功能，Bumble 現在只能在應用程式中使用。",
      "Bumble 現只提供應用程式版本。",
      "不遺漏任何交流",
      "無需分享電話號碼，就能通話",
      "相信你的配對對象真實可信",
      "接收即時推送通知，不錯過任何訊息。",
      "使用應用程式內語音和視訊通話功能，將線上配對變成真實約會，安全放心。",
      "簡易的應用程式內照片和證件驗證功能，讓你放心與已通過驗證的會員聊天。",
      "為什麼要改用 Bumble 應用程式？",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "對不起，無法找到該網頁。",
      "與我們聯絡",
      "糟糕，出錯啦",
      "(opens in new window)",
      "常見問答",
      "Cookie Policy",
      "Premium",
      "Bumble - 博客",
      "工作機會",
      "聊天",
      "城市",
      "管理cookies",
      "版權所有 © 2006 – 至今。Bumble保留所有版權",
      "自信約會報告",
      "Apple和Apple標誌是Apple Inc.的商標。{{__EOL__}}Google Play標誌是Google LLC.的商標",
      "下載",
      "Facebook",
      "追蹤我們",
      "幫助中心",
      "Instagram",
      "語言",
      "LinkedIn",
      "Bumble屬於Bumble Inc",
      "隱私政策",
      "安全中心",
      "網站導覽",
      "現代奴役法案聲明",
      "條款和細則",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "讚美"
            ],
            "singular": [
                  "讚美"
            ]
      },
      "day": {
            "plural": [
                  "日"
            ],
            "singular": [
                  "日"
            ]
      },
      "hour": {
            "plural": [
                  "小時"
            ],
            "singular": [
                  "小時"
            ]
      },
      "minute": {
            "plural": [
                  "分鐘"
            ],
            "singular": [
                  "分鐘"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "superswipe": {
            "plural": [
                  "超級滑動"
            ],
            "singular": [
                  "超級滑動"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
